import request from '../request';
import { SearchDataEsim } from '../../shared/interface/esimManagement.interface';

export const getListEsim = async (searchParams: SearchDataEsim) => {
  const res = await request('get', '/api/inventory-esim/esim-manage-distributor-active', {
    ...searchParams,
  });
  if (res) {
    return res;
  }
};
